import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProjectDetailsSection from './components/ProjectDetailsSection';
import AsSeenOn from './components/AsSeenOn';
import LocationMap from './components/LocationMap';
import SitePlanSection from './components/SitePlanSection';
import LayoutSection from './components/LayoutSection';
import CTABanner from './components/CTABanner';
import ShowflatSection from './components/ShowflatSection';
import FAQSection from './components/FAQSection';
import GallerySection from './components/GallerySection';
import EnquiryFormSection from './components/EnquiryFormSection';
import Footer from './components/Footer';
import SEOHead from './components/SEOHead';

export default function HomePage() {
  return (
    <div className="min-h-screen" style={{ fontFamily: '"Inter", sans-serif' }}>
      <SEOHead />
      <Navbar />
      {/* Offset for sticky navbar */}
      <div className="pt-16">
        <Hero />
        <ProjectDetailsSection />
        <AsSeenOn />
        <LocationMap />
        <SitePlanSection />
        <LayoutSection />
        <CTABanner />
        <ShowflatSection />
        <FAQSection />
        <GallerySection />
        <EnquiryFormSection />
        <Footer />
      </div>
    </div>
  );
}
